import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

//import Backend from 'i18next-http-backend';
//import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';
import srTranslations from './locales/sr.json';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
    resources: {
      en: { translation: enTranslations },
      de: { translation: deTranslations },
      sr: { translation: srTranslations },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    lng: localStorage.getItem('i18nextLng') || 'en', // load language from localStorage
  });
  
export default i18n;
